import React from 'react';
import { Modal, ModalBody, ModalTitle } from '@vds/modals';
import { Accordion, AccordionHeader, AccordionTitle, AccordionItem, AccordionDetail } from '@vds/accordions';



const FaqModal = ({ faqContent, showFaqModal, onOpenedChange }) => {
    return (
    <Modal disableOutsideClick={true} disableFocusLock= {true}  opened={showFaqModal} onOpenedChange={onOpenedChange}>
        <ModalTitle>Frequently asked questions</ModalTitle>
        <ModalBody> 
            <Accordion>
                {faqContent.map(content => {
                    return (
                        <AccordionItem>
                            <AccordionHeader>
                                <AccordionTitle>
                                    {content.title}
                                </AccordionTitle>
                            </AccordionHeader> 
                            <AccordionDetail>{content.description}</AccordionDetail> 
                        </AccordionItem>
                    )
                })}
                
            </Accordion>
        </ModalBody>
    </Modal>
    );
};

export default FaqModal;
